import ko from 'knockout';

export function registerComponent() {
  ko.components.register('sortorder-picker', {
    template: { element: 'sortorder-picker-template' },
    viewModel: {
      createViewModel: function (params, componentInfo) {
        return new SortorderPickerViewModel(params, componentInfo);
      },
    },
  });
}

function SortorderPickerViewModel(params) {
  var self = this;

  self.SortOrderList = params.SortOrder.SortOrderList;
  self.SortOrder = params.SortOrder.SortOrder;
  self.content = ko.observable();
  setContent();

  self.SortOrderList.subscribe(setContent);

  function setContent() {
    self.content(self.SortOrderList().find(o => o.Selected()).Text());
  }
}
